import React, { useState } from 'react';
import { toDateFormatFullMonth } from 'utilities/helper.util';
import { Button, SkeletonText } from 'carbon-components-react';
import { OverflowMenuHorizontal16 } from '@carbon/icons-react';
import { UpgradeModal } from 'components';

const Account: React.FC<Props> = ({ user, userProcess }) => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const { trial_enquiries: trialEnquiries } = user;
  const { enquiries_limit, enquiries_made, next_period } = trialEnquiries;
  const enquiriesRemaining = enquiries_limit - enquiries_made;
  const enquiriesQuota = enquiries_limit;
  const nextPeriod = toDateFormatFullMonth(next_period);

  const handleUpgradePlanClick = () => {
    setIsModalOpen(true);
  };

  return (
    <>
      <div id="account" className="account">
        <div id="mainContent" className="settings-main-content spacing-padding">
          <div className="account-description">
            Hi {user?.first_name}, you are on the Free plan.
          </div>
          <div className="account-information">
            {userProcess === 'refetch' ? (
              <>
                <div className="info-container">
                  <SkeletonText />
                </div>
                <div className="info-container">
                  <SkeletonText />
                </div>
                <div className="info-container">
                  <SkeletonText />
                </div>
              </>
            ) : (
              <>
                <div className="info-container">
                  <div className="info-label">Current:</div>
                  <div className="info-content">
                    You have {enquiriesRemaining <= 0 ? 0 : enquiriesRemaining}{' '}
                    enquiries remaining until your next plan period
                  </div>
                </div>

                <div className="info-container">
                  <div className="info-label">Enquiries:</div>
                  <div className="info-content">{enquiriesQuota} per month</div>
                </div>

                <div className="info-container">
                  <div className="info-label">Next period:</div>
                  <div className="info-content">{nextPeriod}</div>
                </div>
              </>
            )}
          </div>
        </div>
        <div
          id="rightContent"
          className="settings-right-content spacing-padding"
        >
          <div className="upgrade-description">
            Interested in a plan upgrade?
            <br />
            Just submit a request and one of our consultants will be in touch
            soon.
          </div>
          <div className="upgrade-button-container">
            <Button
              kind="tertiary"
              className="button-size"
              renderIcon={OverflowMenuHorizontal16}
              onClick={handleUpgradePlanClick}
            >
              Upgrade my plan
            </Button>
          </div>
        </div>
      </div>
      <UpgradeModal isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} />
    </>
  );
};

interface Props {
  user: any;
  userProcess?: string;
}

export default React.memo(Account);
